import { useState } from 'react';
import { signIn, completeNewPassword } from '../auth';

export default function Login({ onLogin, onGoToSignup }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [pendingUser, setPendingUser] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const token = await signIn(email, password);
      localStorage.setItem('idToken', token);
      onLogin();
    } catch (err) {
      if (err.code === 'NewPasswordRequired') {
        setPendingUser(err.user);
      } else {
        setError(err.message || 'Login failed');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleNewPassword = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) { setError('Passwords do not match'); return; }
    if (newPassword.length < 8) { setError('Password must be at least 8 characters'); return; }
    setError('');
    setLoading(true);
    try {
      const token = await completeNewPassword(pendingUser, newPassword);
      localStorage.setItem('idToken', token);
      onLogin();
    } catch (err) {
      setError(err.message || 'Failed to set password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="logo">
          <div style={{ fontSize: 40 }}>💰</div>
          <h2>DuesTrack</h2>
          <p>Sign in to your account</p>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        {!pendingUser ? (
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label>Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} required />
            </div>
            <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: 8 }} disabled={loading}>
              {loading ? 'Signing in…' : 'Sign In'}
            </button>
            {onGoToSignup && (
              <p style={{ textAlign: 'center', marginTop: 16, fontSize: 14, color: 'var(--muted)' }}>
                Don't have an account?{' '}
                <span style={{ color: 'var(--navy)', cursor: 'pointer', fontWeight: 600 }} onClick={onGoToSignup}>Sign up free</span>
              </p>
            )}
          </form>
        ) : (
          <form onSubmit={handleNewPassword}>
            <p style={{ marginBottom: 16, fontSize: 14, color: '#374151' }}>
              First login — please set a new password.
            </p>
            <div className="form-group">
              <label>New Password</label>
              <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} required />
            </div>
            <div className="form-group">
              <label>Confirm Password</label>
              <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required />
            </div>
            <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }} disabled={loading}>
              {loading ? 'Setting password…' : 'Set Password & Log In'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
